<script>
export default {
  props: {
    show: Boolean,
    result: {
      type: Object,
      default: () => ({
        total_diproses: 0,
        jumlah_berhasil: 0,
        jumlah_gagal: 0,
        gagal: [],
      }),
    },
  },

  computed: {
    modalShow: {
      get() {
        return this.show;
      },
      set(val) {
        if (!val) this.$emit("close");
      },
    },
  },
};
</script>

<template>
  <b-modal
    v-model="modalShow"
    title="Hasil Approve Semua Peserta"
    size="lg"
    hide-footer
  >
    <table class="table table-sm mb-3">
      <tbody>
        <tr>
          <td>Total Diproses</td>
          <td>:</td>
          <td>{{ result.total_diproses }}</td>
        </tr>
        <tr>
          <td>Total Berhasil</td>
          <td>:</td>
          <td>{{ result.jumlah_berhasil }}</td>
        </tr>
        <tr>
          <td>Total Gagal</td>
          <td>:</td>
          <td>{{ result.jumlah_gagal }}</td>
        </tr>
      </tbody>
    </table>

    <div v-if="result.gagal && result.gagal.length > 0">
      <h6 class="fw-bold">Peserta yang tidak berhasil disetujui</h6>
      <div class="table-responsive">
        <table class="table table-sm table-bordered bg-white mb-0">
          <thead>
            <tr>
              <th>NIP</th>
              <th>Nama</th>
              <th>Profesi</th>
              <th>Alasan Gagal</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in result.gagal" :key="index">
              <td>{{ item.nip }}</td>
              <td>{{ item.nama }}</td>
              <td>{{ item.nama_profesi }}</td>
              <td>{{ item.alasan }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="text-end mt-3">
      <b-button variant="secondary" @click="$emit('close')">Tutup</b-button>
    </div>
  </b-modal>
</template>
